import Vue, { ComponentOptions } from 'vue';
import App from './App.vue';
import Router, { Route, RouteConfig } from 'vue-router';
import '@/styles/common.less';
import '@/common';
import { toast } from '@mx/vix';
import { bridge, env } from '@/common';
import '@/common/monitor';
import errorPage from '@/service/errorPage';

if (KNB && KNB.mesh && KNB.mesh.setUp) {
  KNB.mesh.setUp({
    businessId: 'pay-setting', // 必填，使用方id
    devMode: env.runtime > 1, // 选填，在浏览器 JS Console 中，true: 打印日志；false: 隐藏日志，默认值：false
    env: env.runtime > 1 ? 'test' : 'prod'
    // 只有test和prod
  });
}
Vue.use(Router);

export default async function init(
  routes: RouteConfig[],
  options?: ComponentOptions<any>
) {
  const router = new Router({
    routes
  });

  Vue.use(errorPage, { router });

  router.beforeEach((to: Route, from: Route, next: () => void) => {
    toast.show();
    next();
  });

  router.beforeResolve((to: Route, from: Route, next: () => void) => {
    toast.hide();
    next();
  });

  router.afterEach((to: Route, from: Route) => {
    if (to.meta && to.meta.title) {
      bridge.setTitle(to.meta.title);
    }
  });

  Vue.config.productionTip = false;

  await env.initEnv();

  new Vue({
    ...options,
    router,
    mounted() {
      KNB.use('eh.show');
    },
    render: (h) => h(App)
  }).$mount('#app');
}
